import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	BarElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
	ChartData,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	BarElement,
	Title,
	Tooltip,
	Legend,
	Filler,
);

const DEFAULT_OPTIONS = {
	scales: {
		y: {
			beginAtZero: true,
			ticks: {
				fontSize: 18,
				stepSize: 20,
			},
		},
	},
	responsive: true,
	plugins: {
		legend: {
			display: false,
		},
	},
};

interface FloatingBarsChartProps {
	data: ChartData<'bar', number[], unknown>;
	options?: any;
}

const FloatingBarsChart: React.FC<FloatingBarsChartProps> = ({
	data,
	options,
}) => {
	return <Bar options={options ?? DEFAULT_OPTIONS} data={data} />;
};

export default FloatingBarsChart;
